"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePortal = void 0;
var react_1 = require("react");
var usePortal = function (portalContext) {
    var portal = react_1.useContext(portalContext);
    return portal;
};
exports.usePortal = usePortal;
//# sourceMappingURL=usePortal.js.map